import { render } from "./Outcome_information.vue?vue&type=template&id=5640d686"
import script from "./Outcome_information.vue?vue&type=script&lang=js"
export * from "./Outcome_information.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__